// extracted by mini-css-extract-plugin
export default {"page-shop":"notification_page-shop__GlurA","title":"notification_title__rqlT4","noti-content":"notification_noti-content__FARJq"};